import { render, staticRenderFns } from "./ItemReservation.vue?vue&type=template&id=704b1318&"
import script from "./ItemReservation.vue?vue&type=script&lang=js&"
export * from "./ItemReservation.vue?vue&type=script&lang=js&"
import style0 from "./ItemReservation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports